import { hasFeatureEnabled } from 'js/src/libs/server-utils';
import type { DAMConfig } from 'js/src/typings/global';
import Cookies from 'js-cookie';

const Flags = {
    canUseStaffControls: (): boolean => {
        return hasFeatureEnabled('staff_controls');
    },
    canSeeDamTab: (): boolean => {
        if (!window.SERVER?.USER?.dam_configs) {
            return false;
        }
        const damConfigs = window.SERVER.USER.dam_configs;
        return damConfigs.some((damConfig: DAMConfig) => {
            if (damConfig.require_connection && damConfig.is_connected) {
                return true;
            }
            if (!damConfig.require_connection) {
                return true;
            }
            return false;
        });
    },
    canUseBrandReview: () => {
        return hasFeatureEnabled('can_use_brand_review');
    },
    canSeeAiContextSettings: () => {
        return hasFeatureEnabled('ai_context_settings');
    },
    canUseChat: () => {
        return hasFeatureEnabled('chat');
    },
    canUseStickers: () => {
        return hasFeatureEnabled('stickers');
    },
    canUseAssignStickers: () => {
        return hasFeatureEnabled('assign_stickers');
    },
    chatTabDeveloperToolsEnabled: () => {
        return Cookies.get('chat_tab_developer_tools') === 'true';
    },
    canUseImproveObviousIssuesSubagent: () => {
        return hasFeatureEnabled('improve_obvious_issues_subagent');
    },
    isTOMDisabled: () => {
        return hasFeatureEnabled('tom_disabled');
    },
    canUseMovableCaption: () => {
        return hasFeatureEnabled('movable_caption');
    },
    canUseScreenRecording: () => {
        return hasFeatureEnabled('screen_recording');
    },
    canUseBlueprintAgent: () => {
        return hasFeatureEnabled('blueprint_agent');
    },
    canUseImproveMediaAgent: () => {
        return hasFeatureEnabled('improve_media_agent');
    },
    canUseAgentFamily: () => {
        return Flags.canUseImproveMediaAgent() || Flags.canUseBlueprintAgent();
    },
    canUseVideoGeneration: () => {
        return hasFeatureEnabled('video_generation');
    },
    canUseBuildVideoFromMediaAgent: () => {
        return hasFeatureEnabled('build_video_from_media_agent');
    },
    canUseBuildGenerativeMediaVideoAgent: () => {
        return hasFeatureEnabled('build_video_with_generative_media_agent');
    },
    useLowLuminaryResolution: () => {
        return hasFeatureEnabled('low_luminary_resolution');
    },
};

export default Flags;
